/**
 * This function is used to get the valid next bill date timestamp
 * If the next bill date is less than the actual product next bill date, then the next bill date will be incremented by 1 month
 *
 * e.g for Confluence on today date (4th march) changing the next bill date to 28th March
 *    Confluence(Trial or Paid): 30th March (Actual Next Bill Date)
 *    New Next Bill Date: 28th March (Less than actual next bill date)
 *    Then the next bill date will be incremented by 1 month and the next bill date will be 30th April
 *    valid next bill date will be 30th April
 *
 * e.g Same for Jira families and linked apps on today date (4th march) changing the next bill date to 16th March
 *    JSW ( Trial ): 20th March (Actual Trial end Date)
 *    JSM: 15th March (Actual Next Bill Date)
 *    JWM: 15th March (Actual Next Bill Date)
 *    New Next Bill Date: 16th March ( Greater than actual next bill date for JSM and JWM)
 *    Then the next bill date will be 16th March for JSM and JWM
 *    Then the next bill date will be incremented by 1 month and the next bill date will be 15th April for JSW
 *    valid next bill date will be 15th April for JSW
 */
export const getValidNextBillDateTimeStamp = (
  productCurrentNextBillDate: string,
  newNextBillDateTimestamp: string | undefined
) => {
  let validNextBillTimeStamp = newNextBillDateTimestamp ? newNextBillDateTimestamp : productCurrentNextBillDate; // default value

  if (
    newNextBillDateTimestamp &&
    productCurrentNextBillDate &&
    Number(productCurrentNextBillDate) > Number(newNextBillDateTimestamp)
  ) {
    const validatedBillDate = new Date(Number(newNextBillDateTimestamp));
    validatedBillDate.setMonth(validatedBillDate.getMonth() + 1);
    validNextBillTimeStamp = validatedBillDate.valueOf().toString();
    return validNextBillTimeStamp;
  }
  return validNextBillTimeStamp;
};
